// extracted by mini-css-extract-plugin
export default {"content":"feedbackformblock_content__aRpd5"};